import {createContext} from "react";

const SegmentContext = createContext({});

export default SegmentContext;